import React from "react";

function TimelineItem(props) {
  return (
    <div className="timeline-item is-info">
      <div className="timeline-marker is-image is-32x32">
        <i className={props.icon} style={{width: "80%", height: "80%", marginLeft: "10%", marginTop: "10%"}}></i>
      </div>
      <div className="timeline-content">
        <p className="heading">{props.date}</p>
        <h1 className="title is-4">{props.company}</h1>
        <p style={{ maxWidth: "25em" }}>{props.summary}</p>
      </div>
    </div>
  );
}

export default TimelineItem;
